var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCycl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65 65",
    style: {
      enableBackground: "new 0 0 65 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.7,42c-0.7,0-1.3,0.1-2,0.2l-2.4-8l-1.9,0.7l2.3,7.8c-2.2,0.8-4,2.3-5.4,4.1l-0.7-0.4l-0.9,1.8l0.6,0.3      c-0.7,1.4-1,3-1,4.7c0,6.2,5.1,11.3,11.3,11.3c6.2,0,11.3-5.1,11.3-11.3C64,47,58.9,42,52.7,42z M49.4,44.6l2,6.6l-6.1-3.4      C46.3,46.4,47.7,45.2,49.4,44.6z M52.7,62.5c-5.1,0-9.3-4.2-9.3-9.3c0-1.3,0.3-2.6,0.8-3.7l8.3,4.6c0.8,0.4,1.7-0.3,1.4-1.2      l-2.6-8.9c0.5-0.1,0.9-0.1,1.4-0.1c5.1,0,9.3,4.2,9.3,9.3C62,58.3,57.8,62.5,52.7,62.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,52.6c-0.3-5.4-4.4-9.8-9.7-10.5l0.1-1c-1.3-0.7-2.5-1.8-3.3-3.2c-0.9,0.1-3-0.5-3,1c0,0.6,0.4,1,1,1H12l-0.1,2      C5.8,42.2,1,47.2,1,53.2c0,6.2,5,11.3,11.3,11.3c6.2,0,11.5-5.1,11.2-11.6c0,0,0-0.1,0-0.1C23.5,52.7,23.5,52.7,23.5,52.6z       M13.7,44.1c3.9,0.6,7,3.7,7.7,7.7h-8.1L13.7,44.1z M12.3,62.5c-5.1,0-9.3-4.2-9.3-9.3c0-4.9,3.9-9,8.7-9.2l-0.5,8.7      c0,0.6,0.4,1,1,1h9.2C21.2,58.6,17.2,62.5,12.3,62.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.9,7.1c0-3.6,3-6.6,6.6-6.6c3.6,0,6.6,2.9,6.6,6.6c0,3.6-3,6.6-6.6,6.6C39.9,13.6,36.9,10.7,36.9,7.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.7,30.7l-13.6,5.4c-2.3,0.9-4.9-0.8-4.9-3.3v-3l-6.5,5.5L39.5,39c2.1,0.6,3.2,3,2.2,5L36,55.8c-0.8,1.8-3,2.5-4.8,1.7     c-1.8-0.9-2.5-3-1.7-4.8l3.9-8.1c-6.1-1.8-14.4-4.1-15.3-4.3c-6.5-0.1-9.3-8.2-4.4-12.3l15.8-13.4c2.9-2.5,7.3-2.2,9.8,0.8     c1.9,1.7,1.5,7.8,1.2,12.1l8.6-3.4c2-0.7,3.9,0.3,4.6,2C54.5,27.9,53.6,30,51.7,30.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycl);
export default __webpack_public_path__ + "static/media/CYCL.23c05276e6e1ee261d9fee94b7ad9249.svg";
export { ForwardRef as ReactComponent };